<template>  
  <div class="buynow">
    <input type="hidden" id="buynow-starttime">
    <input type="hidden" id="buynow-endtime">
    <img :src="src" class="bg">
    <div class="countdown">
        <span class="desc">还剩</span>
        <span class="time hour1">{{hour1}}</span>
        <span class="time hour2">{{hour2}}</span>
        <span class="font">时</span>
        <span class="time minute1">{{mm1}}</span>
        <span class="time minute2">{{mm2}}</span>
        <span class="font">分</span>
        <span class="time secend1">{{ss1}}</span>
        <span class="time secend2">{{ss2}}</span>
        <span class="font">秒</span>
    </div>
    <div class="product-list">
      <template v-if="leftObj">
        <div class="img-box working">
          <div class="padding">
            <img class="bn-img" :src="leftObj.ImgPath?leftObj.ImgPath:IMGServer_URL+'/images/index-item-default.png'">
          </div>
        </div>
        <div class="info-box working">
          <p class="name">{{leftObj.ProductName}}</p>
          <p class="price">
            <span class="buynow-price" v-if="leftmodel == 1">￥{{leftObj.BuyNowPrice}}</span>
            <span class="buynow-price" v-else-if="leftmodel == 2">￥??</span>
            <span class="buynow-price" v-else-if="leftmodel == 3">￥{{leftObj.BuyNowPrice}}</span>
            <span class="buynow-price-desc">元</span>
            <span class="sku-price">￥{{leftObj.Price}}元</span></p>
          <div class="btn">
            <span class="stock">库存:{{leftObj.Stock - leftObj.BuyCount}}</span>
            <div class="btn-box">
              <template v-if="leftmodel == 1">
                <router-link :to="'/retail/BuyNowOrderSubmit?pId='+leftObj.BuyNowProductId+'&skuId=' + leftObj.SkuId" v-if="leftObj.Stock - leftObj.BuyCount > 0"><div class="botton red">立即抢购</div></router-link>
                <div class="botton" v-else>已抢光</div>
              </template>
              <template v-else-if="leftmodel == 2">
                <div class="botton">未开始</div>
              </template>
              <template v-else-if="leftmodel == 3">
                <div class="botton">已结束</div>
              </template>
            </div>
          </div>
        </div>
      </template>
      <template v-if="rightObj">
        <div class="img-box wait">
          <div class="padding">
            <img :src="rightObj.ImgPath?rightObj.ImgPath:IMGServer_URL+'/images/index-item-default.png'" class="bn-img" />
          </div>
          <div class="zz">
            <div class="box">
              <img src="/static/active/sd.png" class="sd-bg" />

              <div v-if="rightmodel==1">
                <p class="desc" v-if="leftObj.Stock - leftObj.BuyCount > 0">抢购中</p>
                <p class="desc" v-else>已卖完</p>
              </div>
              <div v-else-if="rightmodel==2">
                <p class="desc">即将开始</p>
              </div>
              <div v-else-if="rightmodel==3">
                <p class="desc">已结束</p>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-if="!rightObj">
        <div class="img-box wait">
          <div class="padding">
            <img :src="IMGServer_URL+'/images/index-item-default.png'" class="bn-img" />
          </div>
          <div class="zz">
            <div class="box">
              <img src="/static/active/sd.png" class="sd-bg" />
              <div>
                <p class="desc">已结束</p>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name:'XR-mobile-buynow',
  props: {
    src: {
      type: String,
      default: '/static/index/miaosha.gif'
    }
  },
  data() {
    return {
      productList:[],
      leftObj:{},
      rightObj:{},
      leftmodel : 0,
      rightmodel : 0,
      startTime :'',
      endTime:'',
      buynowInterval :0,
      hour1:'0',
      hour2:'0',
      mm1:'0',
      mm2:'0',
      ss1:'0',
      ss2:'0'
    }
  },
  mounted:function(){
    this.getBuyNowProductList();
  },
  methods:{    
    countdownEvent : function () {
        //结束倒计时
        if (this.endTime) {
            var ts = (new Date(this.endTime)) - (new Date()); //计算剩余的毫秒数    
            if (ts <= 0) {
                this.getBuyNowProductList();
                clearInterval(this.buynowInterval);
                return;
            }
            this.calcTime(ts);
            return;
        }

        //开始倒计时
        var startTime = this.startTime;
        if (startTime) {
            var ts = (new Date(startTime)) - (new Date()); //计算剩余的毫秒数    
            if (ts <= 0) {
                this.getBuyNowProductList();
                clearInterval(this.buynowInterval);
                return;
            }
            this.calcTime(ts);
            return;
        }
    },
    calcTime : function (ts) {
        var hh = parseInt(ts / 1000 / 60 / 60, 10); //计算剩余的小时数  
        var mm = parseInt(ts / 1000 / 60 % 60, 10); //计算剩余的分钟数  
        var ss = parseInt(ts / 1000 % 60, 10); //计算剩余的秒数  

        this.hour1 = parseInt(hh / 10);
        this.hour2 = hh % 10;
        this.mm1 = parseInt(mm / 10);
        this.mm2 = mm % 10;
        this.ss1 = parseInt(ss / 10);
        this.ss2 = ss % 10;
    },
	//时间戳转换成日期时间
    getTimestamp: function (timestamp) {
		if (timestamp) {
			var date = new Date(timestamp); //时间戳为10位需*1000(为秒)，时间戳为13位的话不需乘1000(毫秒)
			var Y = date.getFullYear();
			var M = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
			var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
			var h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
			var m = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
			var s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
			return Y + "/" + M + "/" + D + " " + h + ":" + m + ":" + s;
		}
    },
    getBuyNowProductList:function(){
	  console.log("this.$route.path:" + this.$route.path)
	  if (this.$route.path != "/"){
		return
	  }
      const ths = this;
      this.$post("/Shop/RetailServer/GetActivityBuyNowWorkingProduct")
      .then(function(res) {
        if (res.IsSuccess) {
          var ts = (new Date(res.Data.NowTimeName)) - (new Date());		  
          if (res.Data.WorkingProducts.length > 0 && res.Data.WaitProducts.length > 0) {//如果有进行中和等待中的
              ths.leftmodel = 1;
              ths.rightmodel = 2;
              ths.leftObj = res.Data.WorkingProducts[0];
              ths.rightObj = res.Data.WaitProducts[0];
              ths.endTime = ths.getTimestamp((new Date(ths.leftObj.EndTimeName)) - ts);
          } else if (res.Data.WorkingProducts.length > 0 && res.Data.EndProducts.length > 0) {//如果有进行中和已结束的
              ths.leftmodel = 1;
              ths.rightmodel = 3;
              ths.leftObj = res.Data.WorkingProducts[0];
              ths.rightObj = res.Data.EndProducts[0];
              ths.endTime = ths.getTimestamp((new Date(ths.leftObj.EndTimeName)) - ts);
          } else if (res.Data.WaitProducts.length > 0 && res.Data.EndProducts.length > 0) {//如果有等待中和已结束的
              ths.leftmodel = 2;
              ths.rightmodel = 3;
              ths.leftObj = res.Data.WaitProducts[0];
              ths.rightObj = res.Data.EndProducts[0];
              ths.startTime = ths.getTimestamp((new Date(ths.leftObj.StartTimeName)) - ts);
          } else if (res.Data.WorkingProducts.length > 0) {    //如果只有进行中的
              ths.leftmodel = 1;
              ths.rightmodel = 1;
              ths.leftObj = res.Data.WorkingProducts[0];
              ths.rightObj = res.Data.WorkingProducts[1];
              ths.endTime = ths.getTimestamp((new Date(ths.leftObj.EndTimeName)) - ts);
          } else if (res.Data.WaitProducts.length > 0) {//如果只有等待中的
              ths.leftmodel = 2;
              ths.rightmodel = 2;
              ths.leftObj = res.Data.WaitProducts[0];
              ths.rightObj = res.Data.WaitProducts[1];
              ths.startTime = ths.getTimestamp((new Date(ths.leftObj.StartTimeName)) - ts);
          } else if (res.Data.EndProducts.length > 0) {//如果只有已结束的
              ths.leftmodel = 3;
              ths.rightmodel = 3;
              ths.leftObj = res.Data.EndProducts[0];
              ths.rightObj = res.Data.EndProducts[1];
          }
          console.log("ths.startTime:" + ths.startTime);
		  console.log("ths.endTime:" + ths.endTime);
          if(res.Data.WaitProducts.length>0 || res.Data.WorkingProducts.length>0){            
            ths.buynowInterval = setInterval(ths.countdownEvent, 1000);
          }
		  if(res.Data.WaitProducts.length == 0 && res.Data.WorkingProducts.length == 0){
			setTimeout(() => {
			  ths.getBuyNowProductList();
			},60000)
		  }
        }
      })
      .catch(function(err) {
        console.log(err);
      });    
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/index/mobile/buynow/buynow.vue